module.exports = __webpack_public_path__ + "static/media/main idea.adc2db18.mp3";